module.exports = __webpack_public_path__ + "static/media/oswebsolutions.f14086ca.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/oswebsolutions.webp
// module id = 348
// module chunks = 0